import { Component, Host, Prop, h } from '@stencil/core';

@Component({
  tag: 'cradlepoint-cta-with-hover-bg',
  styleUrl: 'cta-with-hover-bg.css',
  shadow: true,
})
export class CtaWithHoverBg {
  @Prop() link  : string;
  @Prop() newTab: boolean = false;
  @Prop() icon  : string = 'https://img.cradlepoint.com/auto-mapping-folder/2023/08/blog-cta-icon@2x.png';
  @Prop() text  : string = 'Learn more ways a business can incorporate failover into their operations in our Failover White Paper.';
  @Prop() arrow : string = 'https://img.cradlepoint.com/auto-mapping-folder/2023/08/blog-cta-arrow@2x.png';

  render() {
    return (
      <Host>
        <a href={this.link ? this.link : '#'} target={this.newTab ? '_blank' : '_self'}>
          <img class="icon" src={this.icon} />
          <div class="content">
            <h2>{this.text}</h2>
          </div>
          <img class="arrow" src={this.arrow} alt="cta arrow" />
        </a>
      </Host>
    );
  }

}
